/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, Suspense, useState, useEffect } from 'react';
import {
    Route,
    createRoutesFromElements,
    createBrowserRouter,
    RouterProvider,
    Navigate,
    useNavigate
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useIsAuthenticated } from '@azure/msal-react';
import addNotification from 'react-push-notification';
import { URLS } from './constants/routes';
import { sendMsg } from "./assets/images";
import {
    getTwilioChatToken,
} from "./services/chatServices";
import { GetUserDetails } from "./reduxData";
import { updateUserDetails } from "./dataSlice";
import { GetLoggedInUserData } from "./services/userData";
import Layout from './layout';
const NotFound = React.lazy(() => import("./privateScreens/NotFound"));
const NotFoundLogout = React.lazy(() => import("./publicScreens/NotFoundLogout/NotFoundLogout"))
const CMS = lazy(() => import("./privateScreens/CMS"));
const Dashboard = lazy(() => import("./privateScreens/Dashboard"));
const TTATeam = lazy(() => import("./privateScreens/TTATeam"));
const DeletedChats = lazy(() => import("./privateScreens/DeletedChats"));
const ModerateChats = lazy(() => import("./privateScreens/ModerateChats"));
const ModerateDeletedChats = lazy(() => import("./privateScreens/ModerateDeletedChats"));
const Chat = lazy(() => import("./privateScreens/Chat"));
const Login = lazy(() => import("./publicScreens/Authentication/Login"));
const NotificationTemplates = lazy(() => import("./privateScreens/NotificationTemplates"));
const MasterTemplates = lazy(() => import("./privateScreens/MasterTemplates"));
const Notifications = lazy(() => import("./privateScreens/NotificationDetails"));
const SubscriptionGroups = lazy(() => import("./privateScreens/SubscriptionGroups"));
const EmailTemplate = lazy(() => import("./privateScreens/EmailTemplate"))

const AppRouter = () => {
    const Conversations = require("@twilio/conversations");

    const search = window.location.search;
    const searchParams = new URLSearchParams(search);
    const redirect = searchParams.get("redirect");

    const isLogin = useIsAuthenticated();
    const dispatch = useDispatch();

    const userDetails = GetUserDetails();
    const emailGet = userDetails.chatEmail;
    const [twilioChatToken, setTwilioChatToken] = useState(null);
    const [userClient, setUserClient] = useState(null);

    useEffect(() => {
        if (isLogin && !userDetails.chatEmail) {
            GetLoggedInUserData()
                .then((res) => {
                    dispatch(updateUserDetails(res.data));
                })
                .catch((err) => {
                    console.error('[AppRouter] GetLoggedInUserData failed:', err);
                });
        }
    }, [isLogin]);

    useEffect(() => {
        if (isLogin && redirect) {
            window.location.href = `${window.location.origin}/${redirect}`;
        }
    }, [redirect, isLogin])

    // function isLocationInMsgLocations() {
    //     const msgLocations = [
    //         "/chats/jobs"
    //     ];
    //     const currentPathname = window.location.pathname;

    //     return msgLocations.some(path => {
    //         const pattern = new RegExp('^' + path.replace(/\/<dynamic>/g, '/[\\w\\d-]+') + '$');
    //         return pattern.test(currentPathname);
    //     });
    // }

    const [titleChange, setTitleChange] = useState(false)

    const changeTitle = (msg) => {
        document.title = msg
    }

    const handleVisibilityChange = () => {
        if (document.hidden) {
            // Tab is not visible (user switched to another tab or minimized the browser)
            // console.log('Tab is not visible');
        } else {
            // Tab is visible (user switched back to the tab)
            // console.log('Tab is visible');
            setTitleChange(false)
        }
    };

    useEffect(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        if (!titleChange) {
            changeTitle("TTA Connect");
            return;
        }
        const intervalId = setInterval(() => {
            changeTitle(document.title === `New Message` ? `TTA Connect` : "New Message");
            if (!document.hidden) {
                setTitleChange(false);
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [titleChange])

    const sendNewMessageNotification = (e) => {
        const isInCurrentChat = (e) => {
            const currentSearch = window.location.search;
            const searchParams = new URLSearchParams(currentSearch);
            const groupId = parseInt(searchParams.get("groupId"));
            const otherEmail = searchParams.get("email");
            const projectId = parseInt(searchParams.get("projectId"));
            const isDirectChat = (otherEmail !== null);

            if (userDetails.chatEmail === e.state.author) return true;

            return isDirectChat
                ? !e.conversation._internalState.friendlyName && e.state.attributes?.projectId === projectId && e.state.author === otherEmail
                : e.state.attributes?.projectId === projectId && e.state.attributes?.groupId === groupId
        }

        if (e && e.state.attributes?.main && (!isInCurrentChat(e) || !document.hasFocus())) {
            setTitleChange(true)
            addNotification({
                title: e.state.attributes?.groupName ? `${e.state.attributes?.name} - ${e.state.attributes?.groupName}` : `${e.state.attributes?.name}`,
                message: e.state.attributes?.type === "media" ? `${e.state.attributes?.fileArray.length} file(s) sent` : e.state.body,
                duration: 5000,
                icon: sendMsg,
                onClick: () => {
                    window.focus();

                    const projectId = e.state.attributes?.projectId;
                    const groupId = e.state.attributes?.groupId;
                    const participantEmail = e.state?.author;

                    const searchParams = new URLSearchParams();
                    searchParams.set("projectId", projectId);

                    if (!e.conversation._internalState.friendlyName) {
                        searchParams.set("email", participantEmail);
                    } else {
                        searchParams.set("groupId", groupId);
                    }

                    const newUrl = `/chats/jobs?${searchParams.toString()}`;
                    window.history.pushState({}, '', newUrl);
                    window.dispatchEvent(new PopStateEvent('popstate'));
                },
                native: true
            })
        }
    }

    useEffect(() => {
        if (!userClient) return;

        const handler = (e) => sendNewMessageNotification(e);
        userClient.on("messageAdded", handler);

        return () => {
            userClient.off("messageAdded", handler);
            if (!isLogin) {
                userClient?.removeAllListeners();
                userClient?.shutdown()
            }
        }
    }, [isLogin, userClient])

    useEffect(() => {
        if (emailGet) {
            getLoggedInUsersChatToken()
        }
    }, [emailGet, isLogin])

    useEffect(() => {
        if (twilioChatToken) {
            createLoggedInUserClient()
        }
    }, [twilioChatToken])

    useEffect(() => {
        if (userClient) {
            twilioListerners(userClient)
        }
    }, [userClient])

    const getLoggedInUsersChatToken = () => {
        getTwilioChatToken({ email: emailGet })
            .then((res) => {
                setTwilioChatToken(res.data)
            }).catch(e => {
                console.log("Eee error", e)
            })
    }

    const createLoggedInUserClient = async () => {
        const userClientIns = new Conversations.Client(twilioChatToken)
        userClientIns.on("connectionStateChanged", async (e) => {
            if (e === "connected") {
                console.log(`[createLoggedInUserClient] connected: ${e}`)
                setUserClient(userClientIns)
            } else if (e === "denied") {
                console.log("[createLoggedInUserClient] Denied", userClientIns)
            }
        }
        )
    }

    const twilioListerners = client => {
        client.on("tokenAboutToExpire", async () => {
            console.log("Token about to expire");
            const fetchTokenResponse = await getTwilioChatToken({ email: emailGet })
            const newToken = fetchTokenResponse?.data;
            client.updateToken(newToken);
        });

        client.on("tokenExpired", async () => {
            console.log("Token has expired");
            const fetchTokenResponse = await getTwilioChatToken({ email: emailGet })
            const newToken = fetchTokenResponse?.data;
            client.updateToken(newToken);
        });
    }

    let routes;
    if (isLogin) {
        routes = createBrowserRouter(
            createRoutesFromElements(
                <Route element={<Layout userClient={userClient} />}>
                    <Route path={`${URLS.CHATS}/:tab`} element={<Chat userClient={userClient} Conversations={Conversations} />} />
                    <Route path={URLS.DASHBOARD} element={<Dashboard />} />
                    <Route path={URLS.TTA_TEAM} element={<TTATeam />} />
                    <Route path={`/cms/:activeTab`} element={<CMS />} />
                    <Route path={`/cms/:activeTab/:dashActiveTab`} element={<CMS />} />
                    <Route path={URLS.DELETED_CHATS} element={<DeletedChats userClient={userClient} Conversations={Conversations} />} />
                    <Route path={URLS.MODERATE_CHAT} element={<ModerateChats />} />
                    <Route path={URLS.MODERATE_DELETED_CHATS} element={<ModerateDeletedChats />} />
                    <Route path={URLS.NOTIFICATION_TEMPLATE} element={<NotificationTemplates />} />
                    <Route path={URLS.MASTER_TEMPLATE} element={<MasterTemplates />} />
                    <Route path={URLS.NOTIFICATIONS + "/:id"} element={<Notifications />} />
                    <Route path={URLS.SUBSCRIPTION_GROUPS} element={<SubscriptionGroups />} />
                    <Route path={URLS.EMAIL_TEMPLATE} element={<EmailTemplate />} />
                    <Route path={URLS.EMAIL_TEMPLATE + "/:id"} element={<EmailTemplate />} />
                    <Route path="/" element={<Navigate to={"/chats/jobs"} />} />
                    <Route path="*" element={<NotFound />} exact={true} />
                </Route>
            )
        )
    } else {
        routes = createBrowserRouter(
            createRoutesFromElements(
                <Route element={<Layout userClient={userClient} />}>
                    <Route path={URLS.LOGIN} element={<Login />} />
                    <Route path="*" element={<NotFoundLogout />} exact={true} />
                </Route>
            )
        )
    }

    return (
        <Suspense fallback={"Loading"}>
            <RouterProvider router={routes} />
        </Suspense>
    )
}

export default AppRouter